<template>
  <div class="localimg_pick_panel section-white">
    <div class="line-one">
      <div class="input">
        <el-input
          v-model="filterParams.image_name"
          placeholder="输入图片标题"
          class="input-with-select"
          @change="handleChangeInput"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
          />
        </el-input>
      </div>
      <div class="upload_box">
        <div class="el-upload__tip">
          只能上传jpg/png文件，且不超过2M
        </div>
        <el-upload
          ref="uploader"
          :multiple="true"
          action="#"
          accept="image/jpeg,image/png,image/gif"
          :show-file-list="false"
          :http-request="handleUpload"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          :on-error="uploadError"
        >
          <el-button type="primary">
            本地上传
          </el-button>
        </el-upload>
      </div>
    </div>

    <div
      v-loading="loading"
      class="localimg_pick"
    >
      <ul class="clearfix">
        <li
          v-for="(item, index) in localimagesList.list"
          :key="index"
          class="localimg_item"
        >
          <div class="localimg_item_bd">
            <div
              class="pic"
              :style="{ backgroundImage: 'url(' + item.image_url + ')' }"
            />
            <div class="check_content">
              <span
                class="localimg_name"
                :title="item.image_name"
              >{{ item.image_name }}</span>
            </div>
          </div>
          <div class="msg_card">
            <el-row>
              <el-col :span="24">
                <div
                  class="opr_item"
                  @click="removeItem(item, index)"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                  >
                    <i class="el-icon-delete" />
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
          </div>
        </li>
      </ul>
    </div>
    <div class="tc">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="localimagesList.total_count"
        :page-size="params.page_size"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import UploadUtil from '@/utils/uploadUtil'
export default {
  props: {
    activeName: {
      type: String
    },
    getStatus: {
      type: Boolean
    }
  },
  data () {
    return {
      actionPath: 'https://upload-z2.qiniup.com',
      image_prefix: '',
      postData: {
        token: '',
        key: '',
        fname: ''
      },
      input2: '',
      loading: false,
      isLoadData: false,
      localimagesList: {},
      params: {
        page: 1,
        page_size: 20
      },
      filterParams: {
        image_name: ''
      }
    }
  },
  watch: {
    getStatus (newV, oldV) {
      console.log('--newV--', newV)

      if (newV) {
        this.params = { page: 1, page_size: this.params.page_size }
        this.getList()
      }
    }
  },
  methods: {
    handleChangeInput () {
      this.isLoadData = false
      this.getList()
    },
    beforeAvatarUpload (file) {
      console.log(file, '上传文件')
      const isJPG = file.type === 'image/jpg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      // const isGIF = file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      let index = file.name.lastIndexOf('.')
      let after = file.name.substring(index + 1)
      const imageType = after === 'jpg' || after === 'png'
      console.log(imageType, 'imageType')

      if ((!isJPG && !isJPEG && !isPNG) || !imageType) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        this.$refs.uploader.clearFiles()
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        this.$refs.uploader.clearFiles()
        return
      }

      this.postData.fname = file.name

      let tokenParams = { filename: file.name, filesystem: 'qiniu' }
    },
    handleAvatarSuccess (res, file) {
      let uploadParams = {
        image_cat_id: 2, //图片分类必填,必须为整数
        image_name: file.name, //图片名称必填,不能超过50个字符
        image_url: res.key, //图片链接必填
        // image_full_url: res.height,   //图片完整链接必填
        image_type: file.raw.type, //图片分类长度不能超过20个字符
        storage: 'image' //图片id必填
      }
      // if (res.key) {
      this.$api.qiniu.uploadQiniuPic(uploadParams).then((res) => {
        this.$message({
          message: '上传成功',
          type: 'success',
          duration: 5 * 1000
        })
        this.isLoadData = false
        this.getList()
      })
      // }
    },
    getList () {
      console.log('0000')
      if (!this.isLoadData) {
        this.loading = true

        this.$api.qiniu
          .getQiniuPicList({ ...this.params, ...this.filterParams, storage: 'image' })
          .then((response) => {
            console.log('-response--', response)
            this.localimagesList = response
            this.isLoadData = true
            this.loading = false
          })
          .catch(function (error) {
            this.loading = false
          })
      }
    },
    handleCurrentChange (page_num) {
      this.isLoadData = false
      this.params.page = page_num
      this.getList()
    },
    handleSizeChange (page_size) {
      this.isLoadData = false
      this.params.page = 1
      this.params.page_size = page_size
      this.getList()
    },
    removeItem (item, index) {
      const self = this
      this.$confirm('确定删除此图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          self.$api.qiniu.deleteImage({ image_id: item.image_id }).then((response) => {
            this.localimagesList.list.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 自定义上传
    handleUpload: function (e) {
      const upload = new UploadUtil()
      // 上传
      upload
        .uploadImg(e.file, e.file.name)
        .then(
          (res) => e.onSuccess(res),
          (err) => e.onError(err)
        )
        .catch((err) => e.onError(err))
    },
    // 上传错误回调
    uploadError: function (e) {
      console.error(e)
    }
  }
}
</script>

<style scoped lang="scss">
.upload-demo {
  margin-bottom: 10px;
}
.localimg_pick_panel {
  .line-one {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .upload_box {
      display: flex;
      align-items: center;

      .el-upload__tip {
        margin-top: 0;
        font-size: 16px;
        margin-right: 16px;
      }
    }
  }
  .localimg_pick {
    margin-right: -1%;
    .localimg_item {
      margin-bottom: 20px;
      margin-right: 1%;
      border: 1px solid #e7e7eb;
      width: 19%;
    }
    .localimg_item_bd {
      position: relative;
    }
    .pic {
      width: 100%;
      height: 169px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      border-bottom: 1px solid #e7e7eb;
    }
    .check_content {
      width: 100%;
      padding: 0 5px;
    }
    .localimg_name {
      height: 34px;
      line-height: 34px;
      overflow: hidden;
      display: inline-block;
      width: 90%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.localimg_pick {
  margin-right: -45px;
  .localimg_item {
    float: left;
    text-align: center;
    &:hover {
      -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      -moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    }
  }
}
.msg_card {
  background-color: #f4f5f9;
  border-top: 1px solid #e7e7eb;
  width: 100%;
  .opr_item {
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    color: #999;
    font-size: 16px;
    &:hover {
      color: #333;
    }
  }
}
</style>
